<template>
  <div class="list">
    <ul class="list-items">
      <li v-for="item in items" :key="item[keyField]" class="list-item">
        <a href="#" @click.prevent="selectItem(item)">
          <div class="info">
            <span class="title is-size-6 has-text-weight-semibold has-text-primary">
              <slot name="title" v-bind:item="item"></slot>
            </span>
            <span class="description is-size-7">
              <slot name="description" v-bind:item="item"></slot>
            </span>
          </div>
          <next-arrow-icon></next-arrow-icon>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import NextArrowIcon from "@/components/_base/NextArrowIcon.vue"

export default {
  name: "ItemList",
  props: {
    items: {
      type: Array,
      required: true
    },
    keyField: {
      type: String,
      required: false,
      default: "key"
    }
  },
  components: {
    NextArrowIcon
  },
  methods: {
    selectItem(item) {
      this.$emit("item-selected", item)
    }
  }
}
</script>

<style scoped>
.list .list-items {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 30px;
}

.list-item a {
  color: grey;
  text-decoration: none;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-item .info {
  display: flex;
  flex-direction: column;
}

.list-item {
  color: grey;
  text-decoration: none;
}

.list-item {
  border-top: 1px solid #e0e0e0;
  padding: 10px 5px;
}

.list-item:hover {
  background-color: #fafafa;
}

.list-item:last-child {
  border-bottom: 1px solid #e0e0e0;
}
</style>
